// extracted by mini-css-extract-plugin
export default {"loginModal":"Home_loginModal__-queL","responsiveLargeFont":"Home_responsiveLargeFont__H9H98"};